import { render, staticRenderFns } from "./SettingsUserEditAdditionalDataView.vue?vue&type=template&id=13827d0c&scoped=true&"
import script from "./SettingsUserEditAdditionalDataView.vue?vue&type=script&lang=js&"
export * from "./SettingsUserEditAdditionalDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13827d0c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VForm,VSelect,VSpacer,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13827d0c')) {
      api.createRecord('13827d0c', component.options)
    } else {
      api.reload('13827d0c', component.options)
    }
    module.hot.accept("./SettingsUserEditAdditionalDataView.vue?vue&type=template&id=13827d0c&scoped=true&", function () {
      api.rerender('13827d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/users/edit/SettingsUserEditAdditionalDataView.vue"
export default component.exports